














































import {
  defineComponent,
  onMounted,
  PropType,
  ref,
  useContext,
} from "@nuxtjs/composition-api";
import { SfImage } from "@storefront-ui/vue";
import JetUiButton from "~/components/JetUi/atoms/JetUiButton/JetUiButton.vue";
import { useUiNotification } from "~/composables";
import { useCart } from "~/modules/checkout/composables/useCart";
import { applyCouponCommand } from "~/modules/checkout/composables/useCart/commands/applyCouponCommand";

export default defineComponent({
  name: "CouponItem",
  components: {
    SfImage,
    JetUiButton,
  },
  props: {
    imgDsk: {
      type: String as PropType<string>,
      default: "",
    },
    title: {
      type: String as PropType<string>,
      default: "",
    },
    discount: {
      type: Number as PropType<number>,
      default: 0,
    },
    footer: {
      type: String as PropType<string>,
      default: "",
    },
    coupon: {
      type: String as PropType<string>,
      default: "",
    },
    primary: {
      type: String as PropType<string>,
      default: "#000E78",
    },
    secondary: {
      type: String as PropType<string>,
      default: "#FD612D",
    },
    colorText: {
      type: String as PropType<string>,
      default: "white",
    },
  },
  setup(props) {
    const { cart, load } = useCart();
    const { $vsf } = useContext();
    const { send: sendNotification } = useUiNotification();
    const { app } = useContext();

    const isLoading = ref(false);
    const isHovered = ref(false);

    onMounted(() => {
      load();
    });

    const applyCoupon = async () => {
      isLoading.value = true;
      try {
        const { updatedCoupon, errors } = await applyCouponCommand.execute(
          $vsf,
          {
            currentCart: cart.value,
            couponCode: props.coupon,
          }
        );
        if (errors) {
          sendNotification({
            id: Symbol("cupon_applied"),
            message: `Erro: ${errors[0].message}`,
            persist: false,
            type: "warning",
            icon: "check",
          });
        } else {
          sendNotification({
            id: Symbol("cupon_applied"),
            message: app.i18n.t("Cupom aplicado com sucesso!") as string,
            persist: false,
            type: "success",
            icon: "check",
          });
        }
        load();
      } catch (error) {
        console.error("Error applying coupon:", error);
        sendNotification({
          id: Symbol("cupon_applied"),
          message: "Ocorreu um erro ao aplicar o cupom. Tente novamente.",
          persist: false,
          type: "danger",
          icon: "cross",
        });
      } finally {
        isLoading.value = false;
      }
    };

    return {
      applyCoupon,
      isLoading,
      isHovered,
    };
  },
});
